module.exports = __webpack_public_path__ + "img/9788956371863.beb88521.jpg";